<template>
    <div class="date-time-picker">
        <div class="date-time-picker__field">
            <v-menu
                v-model="dateMenu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
            >
                <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                        v-model="localDate"
                        :label="dateLabel"
                        prepend-inner-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        clearable
                        outlined
                        dense
                        :hide-details="hideDetails || 'auto'"
                        :disabled="disabled"
                        v-on="on"
                    />
                </template>
                <v-date-picker
                    v-model="localDate"
                    :allowed-dates="allowedDates"
                    @input="setDate"
                />
            </v-menu>
        </div>
        <div v-if="displayTime" class="date-time-picker__field">
            <v-menu
                v-model="timeMenu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
            >
                <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                        v-model="localTime"
                        :label="timeLabel"
                        prepend-inner-icon="mdi-clock-time-four-outline"
                        readonly
                        v-bind="attrs"
                        clearable
                        outlined
                        dense
                        :hide-details="hideDetails || 'auto'"
                        :disabled="disabled"
                        v-on="on"
                        @input="setTime"
                    />
                </template>
                <v-time-picker
                    v-model="localTime"
                    format="24hr"
                    @input="setTime"
                />
            </v-menu>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            dateLabel: {
                type: String,
                default: null
            },
            timeLabel: {
                type: String,
                default: null
            },
            date: {
                type: String,
                default: null
            },
            dateRange: {
                type: Array,
                default: null
            },
            disabled: {
                type: Boolean,
                default: false
            },
            time: {
                type: String,
                default: null
            },
            type: {
                type: String,
                default: ''
            },
            displayTime: {
                type: Boolean,
                default: false
            },
            hideDetails: {
                type: Boolean,
                default: false
            }
        },
        data: () => ({
            localDate: null,
            localTime: null,
            dateMenu: false,
            timeMenu: false
        }),
        computed: {
            allowedDates() {
                if (this.type === 'Start') {
                    return val => new Date(val).getDay() === 1
                } else if (this.type === 'End') {
                    return val => new Date(val).getDay() === 0
                } else if (this.dateRange) {
                    return val => new Date(val) >= new Date(this.dateRange[0]) && new Date(val) <= new Date(this.dateRange[1])
                } else {
                    return null
                }
            }
        },
        watch: {
            date() {
                this.localDate = this.date
            },
            time() {
                this.localTime = this.time
            }
        },
        created() {
            this.localDate = this.date
            this.localTime = this.time
        },
        methods: {
            setDate(date) {
                this.$emit('setDate', date)
            },
            setTime(time) {
                this.$emit('setTime', time)
            }
        }
    }
</script>

<style scoped>
    .date-time-picker {
        display: flex;
        flex-wrap: wrap;
        gap: 12px;
    }

    .date-time-picker__field {
        flex: 1 1 140px;
        min-width: 0;
    }
</style>
